import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { AlertSingleLine, Loader, styles } from '@sdir/sds';
import { PersonExtended } from '@sdir/httpclient/lib/clients/core/externallookup';

interface FregInfoProps {
  person?: PersonExtended;
  loading?: boolean;
}

const FregInfo: React.FC<FregInfoProps> = ({ person, loading }) => {
  const intl = useIntl();
  const address = person?.address;

  if (loading) {
    return (
      <Wrapper>
        <Loader size="20px" />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <Address>
        <Label>{intl.formatMessage({ id: 'contactinfo.address' })}</Label>
        {address ? (
          <>
            {address?.address && <BoldText>{address?.address}</BoldText>}
            {address?.addressLine1 && <BoldText>{address?.addressLine1}</BoldText>}
            {address?.addressLine2 && <BoldText>{address?.addressLine2}</BoldText>}
            {address?.addressLine3 && <BoldText>{address?.addressLine3}</BoldText>}
            <BoldText>
              {address?.postalArea || ''} {address?.zipCode || ''}
            </BoldText>
            {address?.country && <BoldText>{address?.country}</BoldText>}
          </>
        ) : (
          <BoldText>{intl.formatMessage({ id: 'contactinfo.noaddressfound' })}</BoldText>
        )}
      </Address>
      <AlertSingleLine
        title=""
        type="info"
        text={intl.formatMessage({ id: 'contactinfo.freginfo' })}
      />
    </Wrapper>
  );
};

export default FregInfo;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
`;

const Address = styled.div`
  margin-bottom: 10px;
`;

const BoldText = styled.p`
  font-weight: bold;
  margin: 0 0 5px 0;
`;

const Label = styled(BoldText)`
  font-size: 1.75rem;
  color: ${styles.colors.font.textTable};
  margin-bottom: 0.5rem;
`;
